function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { decodeCid } from './decode-cid';
import { withTranslation } from 'react-i18next';

function extractInfo(cid) {
  var cidInfo = decodeCid(cid);
  var hashFn = cidInfo.multihash.name;
  var hashFnCode = cidInfo.multihash.code.toString('16');
  var hashLengthCode = cidInfo.multihash.length.toString('16');
  var hashLengthInBits = cidInfo.multihash.length * 8;
  var hashValue = toHex(cidInfo.multihash.digest);
  var hashValueIn32CharChunks = hashValue.split('').reduce(function (resultArray, item, index) {
    var chunkIndex = Math.floor(index / 32);

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
    }

    resultArray[chunkIndex].push(item);
    return resultArray;
  }, []);
  var humanReadable = "".concat(cidInfo.multibase.name, " - cidv").concat(cidInfo.cid.version, " - ").concat(cidInfo.cid.codec, " - ").concat(hashFn, "~").concat(hashLengthInBits, "~").concat(hashValue, ")");
  return {
    hashFn: hashFn,
    hashFnCode: hashFnCode,
    hashLengthCode: hashLengthCode,
    hashLengthInBits: hashLengthInBits,
    hashValue: hashValue,
    hashValueIn32CharChunks: hashValueIn32CharChunks,
    humanReadable: humanReadable
  };
}

var toHex = function toHex(bytes) {
  return Array.prototype.map.call(bytes, function (x) {
    return x.toString(16).padStart(2, '0');
  }).join('').toUpperCase();
};

export var CidInfo = function CidInfo(_ref) {
  var t = _ref.t,
      tReady = _ref.tReady,
      cid = _ref.cid,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["t", "tReady", "cid", "className"]);

  var cidErr = null;
  var cidInfo = null;

  try {
    cidInfo = cid ? extractInfo(cid) : null;
  } catch (err) {
    cidErr = err;
  }

  return !cid ? null : /*#__PURE__*/React.createElement("section", _extends({
    className: "ph3 pv4 sans-serif ".concat(className)
  }, props), /*#__PURE__*/React.createElement("label", {
    className: "db pb2"
  }, /*#__PURE__*/React.createElement("a", {
    className: "tracked ttu f5 fw2 teal-muted hover-aqua link",
    href: "https://docs.ipfs.io/guides/concepts/cid/"
  }, t('CidInfo.header'))), !cidInfo ? null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "f7 monospace fw4 ma0 pb2 truncate gray"
  }, cid), /*#__PURE__*/React.createElement("div", {
    className: "f6 sans-serif fw4 ma0 pb2 truncate",
    id: "CidInfo-human-readable-cid"
  }, cidInfo.humanReadable), /*#__PURE__*/React.createElement("label", {
    htmlFor: "CidInfo-human-readable-cid",
    className: "db fw2 ma0 gray ttu f7 tracked"
  }, t('base'), " - ", t('version'), " - ", t('codec'), " - ", t('multihash')), /*#__PURE__*/React.createElement("a", {
    href: "https://github.com/multiformats/multihash#visual-examples",
    className: "dib tracked ttu f6 fw2 teal-muted hover-aqua link mt4"
  }, t('multihash')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "dib monospace f6 pt2 tr dark-gray lh-title ph2"
  }, /*#__PURE__*/React.createElement("code", {
    className: "gray"
  }, "0x"), /*#__PURE__*/React.createElement("span", {
    className: "orange"
  }, cidInfo.hashFnCode), /*#__PURE__*/React.createElement("span", {
    className: "green"
  }, cidInfo.hashLengthCode), /*#__PURE__*/React.createElement("span", {
    id: "CidInfo-multihash"
  }, cidInfo.hashValueIn32CharChunks.map(function (chunk) {
    return /*#__PURE__*/React.createElement("span", {
      key: chunk.join('')
    }, chunk.join(''), /*#__PURE__*/React.createElement("br", null));
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: "CidInfo-multihash",
    className: "sans-serif fw2 ma0 gray ttu f7 tracked"
  }, t('CidInfo.hashDigest')), /*#__PURE__*/React.createElement("div", {
    className: "tl lh-copy"
  }, /*#__PURE__*/React.createElement("a", {
    className: "db link orange pt2",
    href: "https://github.com/multiformats/multicodec/blob/master/table.csv"
  }, /*#__PURE__*/React.createElement("code", {
    className: "gray"
  }, "0x"), /*#__PURE__*/React.createElement("code", null, cidInfo.hashFnCode), " = ", cidInfo.hashFn), /*#__PURE__*/React.createElement("div", {
    id: "CidInfo-multihash",
    className: "green"
  }, /*#__PURE__*/React.createElement("code", {
    className: "gray"
  }, "0x"), /*#__PURE__*/React.createElement("code", null, cidInfo.hashLengthCode), " = ", cidInfo.hashLengthInBits, " bits"))))), !cidErr ? null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "f5 sans-serif fw5 ma0 pv2 truncate navy"
  }, cid), /*#__PURE__*/React.createElement("div", {
    className: "red fw2 ma0 f7"
  }, cidErr.message)));
};
export default withTranslation('explore')(CidInfo);